import { useContext } from "react";

import { AudioContext, State } from "providers/AudioProvider";

export const useAudio = (): State => useContext(AudioContext);